"use strict";

import Swiper from "swiper";
import { Autoplay, FreeMode } from 'swiper/modules';
import "swiper/css";

const swipers = document.querySelectorAll(
    ".wp-block-pulp-logo-highlights .swiper"
);

swipers.forEach((el, index) => {
    const swiper = new Swiper(el, {
        modules: [Autoplay, FreeMode],
        slidesPerView: "auto",
        loop: true,
        spaceBetween: window.innerWidth < 1025 ? 20 : 50,
        speed: 3000,
        autoplay: {
            delay: 0 // this prevent pauseOnMouseHover from working
        },
        // freeMode: {
        //     enabled: true
        // },
        allowTouchMove: false,
        disableOnInteraction: false,
        // pauseOnMouseEnter: false
    });
});
